import React, { useEffect, useRef, useState } from "react";
import { Card, Modal, Typography } from "antd";
import newStyled from "@emotion/styled";
import axios from "axios";
import DemoAIModal from "../../components/modals/DemoAIModal";
import { base_url } from "../../utils/apiConfig";
import { useFetchRepAttachmentsID } from "../../utils/hooks/IndReport";
const { Text, Title } = Typography;

const AiCardSection = ({
  title,
  storeCode,
  storeName,
  reportSummary,
  allSecondApiData,
  auditStoreId,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [textLength, setTextLength] = useState(100);
  const [showSenti, setShowSenti] = useState(false);
  const viewref = useRef(null);
  const apiModalData = Array.isArray(allSecondApiData)
    ? allSecondApiData
    : [allSecondApiData];
  const numericAuditStoreId = Number(auditStoreId);
  const {
    data: insightsData,
    getApiData: getinsightsData,
    isLoading: insightsLoading,
  } = useFetchRepAttachmentsID();

  const handleViewAi = async () => {
    try {
      setShowSenti(true);
      console.log("sentiment data id: ", numericAuditStoreId);
      await getinsightsData(`sentiment_data/${numericAuditStoreId}`);
      viewref.current.click();
    } catch (error) {
      console.log("Error fetching AI insights:", error.message);
    }
  };
  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const fetchReportData = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.get(
        `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/audit_store/${auditStoreId}`,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        },
      );
      console.log("API Response:", response.data);
      window.open(`/auditReport/${auditStoreId}`, "_blank");
    } catch (error) {
      console.log("Error fetching report data:", error);
    }
  };
  const handleViewReportClick = () => {
    fetchReportData();
  };

  useEffect(() => {
    const updateTextLength = () => {
      if (window.innerWidth <= 320) {
        setTextLength(12);
      } else if (window.innerWidth <= 399) {
        setTextLength(18);
      } else if (window.innerWidth <= 465) {
        setTextLength(20);
      } else if (window.innerWidth <= 768) {
        setTextLength(30);
      } else {
        setTextLength(50);
      }
    };

    updateTextLength();
    window.addEventListener("resize", updateTextLength);

    return () => {
      window.removeEventListener("resize", updateTextLength);
    };
  }, []);

  const handleClickViewAi = () => {
    handleOpenModal();
    handleViewAi();
  };

  const toggleExpand = () => setExpanded(!expanded);
  return (
    <>
      <CardStyle
        // bordered={true}
        variant="outlined"
        style={{
          borderRadius: "8px",
          backgroundColor: "#FAFAFA",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Card>
          <div style={{ marginBottom: "10px", padding: "4px" }}>
            <Text className="text-nps">{title}</Text>
          </div>
          <div style={{ marginBottom: "10px", padding: "0px 4px" }}>
            <Text strong className="leftText">
              Store code:{" "}
            </Text>
            <Text className="rightText">{storeCode}</Text>
          </div>
          <div style={{ marginBottom: "10px", padding: "0px 4px" }}>
            <Text strong className="leftText">
              Store:{" "}
            </Text>
            <Text className="rightText">{storeName}</Text>
          </div>

          <div
            style={{
              display: "flex",
              gap: "10px",
              marginBottom: "10px",
              alignItems: "center",
              padding: "4px",
            }}
          >
            <div
              className="view-AiBtn d-flex gap-1 align-items-center"
              style={{ cursor: "pointer" }}
              onClick={handleClickViewAi}
            >
              <div className="iconStar my-2">
                <i className="bi bi-stars"></i>
              </div>
              <p className="my-2">View AI Insights</p>
            </div>
            <div className="view-report-ai df" onClick={handleViewReportClick}>
              <p className="my-3">View Report</p>
            </div>
          </div>
        </Card>

        <div className="reportSummary">
          <Title level={5} style={{ color: "#007dc1", fontWeight: 700 }}>
            Report Summary
          </Title>
        </div>
        <div className="ai-report-summary">
          <div className={`summary-ai-text ${expanded ? "expanded" : ""}`}>
            {reportSummary}
          </div>

          {reportSummary?.split(" ").length > 50 && (
            <button className="show-more-ai-btn" onClick={toggleExpand}>
              {expanded ? "Show Less" : "Read More"}
            </button>
          )}
        </div>
      </CardStyle>

      <DemoAIModal
        viewref={viewref}
        showSenti={showSenti}
        setShowSenti={setShowSenti}
        insightsData={insightsData}
        isLoading={insightsLoading}
      />
    </>
  );
};

const CardStyle = newStyled(Card)`
  :where(.css-dev-only-do-not-override-1kf000u).ant-card .ant-card-body {
    @media (max-width: 476px) {
      padding: 0px !important;
    }
  }
`;

export default AiCardSection;
